import Vue from 'vue';
import Services from './Services';
import i18n from '../../translations/i18n';
import { getFullUrl } from '../../util/url';
import initApp from '../../util/init-app';

Vue.config.productionTip = false;
Vue.prototype.$url = getFullUrl;

initApp({
  isPublic: true,
  i18n,
  render: (h) => h(Services),
});
